import { BulkEpisodeStats } from '../types';

/** mapping_status -> antd Tag 색상 */
export const rowStatusColor = (status: string): string => {
  const map: Record<string, string> = {
    matched: 'green',
    duplicate: 'orange',
    invalid: 'red',
    out_of_range: 'volcano',
    committed: 'blue',
    skipped: 'default',
    failed: 'red',
    pending: 'default',
  };
  return map[status] ?? 'default';
};

/** MATCHED 행이 1건 이상일 때만 승인(commit) 가능 */
export const canApprove = (stats?: BulkEpisodeStats | null): boolean =>
  !!stats && stats.matched > 0;
